const getTranslationKeyOfError = (value) => {
  switch (value) {
    case "422":
      return "authorization.something_went_wrong_please_try_again_later";
    case "duplicate_email":
      return "authorization.duplicate_email";
    case "invalid_referral_code":
      return "authorization.invalid_referral_code";
    case "disposable_email_not_allowed":
      return "authorization.disposable_email_not_allowed";
    default:
      return "authorization.something_went_wrong_please_try_again_later";
  }
};

export { getTranslationKeyOfError };
